module.exports = __webpack_public_path__ + "static/media/calendar.103c8d65.svg";